import React from "react";
import ShareButton from "../ShareButton.jsx";

const SMSButton = ({ mediaShareURL, shareText, mediaType, gameData, sectionName, showLabel }) => {
  const getIconSource = (sectionName) => {
    if (sectionName === "Full Story") {
      return "./img/es-message-icon.svg"; // Icon for sharing full story
    }
    return "./img/share_icon_circle_link.svg"; // Default white icon for others
  };

  return (
    <ShareButton
      onClick={() => (window.location.href = "sms:?&body=" + shareText + " " + encodeURIComponent(mediaShareURL))}
      source={getIconSource(sectionName)}
      btnName="SMS"
      mediaType={mediaType}
      gameData={gameData}
      sectionName={sectionName}
      btnLabel={showLabel ? "Message" : ""}
    />
  );
};

export default SMSButton;
